/**
 * Compile-time feature flags (04-architecture § 5.3).
 *
 * Later-phase code must not be reachable by accident, so the flags are derived
 * from `PHASE`, not from runtime data. A location that is not `open` is handled
 * by data, never by a flag.
 */

function readPhase(): 1 | 2 {
  const raw =
    (typeof process !== 'undefined' ? process.env?.EXPO_PUBLIC_PHASE : undefined) ??
    (typeof import.meta !== 'undefined'
      ? (import.meta as { env?: Record<string, string> }).env?.VITE_PHASE
      : undefined);
  return raw === '2' ? 2 : 1;
}

export const PHASE: 1 | 2 = readPhase();

export const flags = {
  /** Locker add-on (P2, D-083). */
  lockers: PHASE >= 2,
  /** Team screens and routes (P2, D-081). */
  teams: PHASE >= 2,
  /** Voucher row in the day-ticket checkout, priority-window hints (P2, D-086). */
  vouchers: PHASE >= 2,
  /** PrivateDesk in the member web funnel (P2). */
  privateDeskWeb: PHASE >= 2,
  /** "Zahlen" and the monthly report in admin (P2). */
  analytics: PHASE >= 2,
  /** Android foreground-service detection (07 § 6). */
  androidAutoDetect: true,
} as const;

export type Flag = keyof typeof flags;
